import React from "react";
import {} from "../../../Redux/Actions/actions";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    chatBotLink: contactListData.chatBotLink,
  };
};

const ChatBotScript = (props) => {
  return (
    <div className="d-flex justify-content-center h-100 w-100">
      <iframe
        src={props.chatBotLink.link}
        style={{ width: "100vw", height: "90vh" }}
      ></iframe>
    </div>
  );
};

export default connect(mapStateToProps, {})(ChatBotScript);
